import {FlowPort} from '@mintdata-wsp/common/state/ui/visualDesigner/FlowState';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./FlowPortPopup.less');
const cx = classnames.bind(styles);

export interface FlowPortPopupProps
{
    port:FlowPort;
    isVisible:boolean;
}

@observer
export class FlowPortPopup extends React.Component<FlowPortPopupProps, any>
{
    render()
    {
        const {port, isVisible} = this.props;

        return <div className={cx('portPopup',
            {'visible': isVisible},
            {'notVisible': !isVisible}
        )}>

            <div className={cx('text')}>
                {port.name}
            </div>
            {/*<div className={cx('connector')}>*/}
            {/*</div>*/}

        </div>;
    }
}




